export default __webpack_public_path__ + "static/media/Group9185.882343b9.svg";